export const CALL_REFETCH_DELAY = 60000
export const CALL_WARNING_BEFORE = 10 * 60 * 1000
